import React from 'react'
import { IconDelete, IconInfo, IconEdit } from 'components/Zui/Icon'
import { useAuth, useIntl } from 'hooks'
import { getExpiryDays } from 'utils/datetime'
import { userStatusLabel } from './constants'
import { Button, StateLabel } from 'components/Zui'
import './table.css'

const Index = ({ data, onDeleteUser, onWithdrawInvitation, onUserDetailsOpen, onEditOpen }) => {
    const { authUser } = useAuth()
    const { t } = useIntl()

    const removeUser = user => {
        if (user.onboardingStatus === 'Invited') {
            onWithdrawInvitation(user.id)
        } else {
            onDeleteUser(user.id)
        }
    }

    return (
        <table className="user-table">
            <thead>
                <tr>
                    <td>{t('label.NAME')}</td>
                    <td className="user-email-table-header-col">{t('label.E.MAIL')}</td>
                    <td className="user-status-label">{t('label.STATUS')}</td>
                    <td className="user-info-icon"></td>
                    <td className="user-delete-icon"></td>
                </tr>
            </thead>
            <tbody>
                {data?.map(user => {
                    return (
                        <tr className="user-table-row" key={user.id}>
                            <td>
                                {' '}
                                {user.onboardingStatus !== 'Invited' &&
                                    [user.lastName, user.firstName].filter(Boolean).join(', ')}
                                {user.onboardingStatus === 'Invited' && (
                                    <span className="email-sm invited-user-email">
                                        {user.emailId}
                                    </span>
                                )}
                            </td>
                            <td
                                className={`user-email-table-body-col ${
                                    user.onboardingStatus === 'Invited' ? 'invited-user-email' : ''
                                }`}
                            >
                                {user.emailId}
                            </td>

                            <td className={userStatusLabel[user.onboardingStatus].classname}>
                                {user.onboardingStatus === 'Invited' && (
                                    <p className="max-user-message">
                                        {t('invitation.expires')} <br />
                                        {t('in.x.days', {
                                            days: getExpiryDays(user.createdDateTime),
                                        })}
                                    </p>
                                )}
                                <StateLabel state={userStatusLabel[user.onboardingStatus].state}>
                                    {user.onboardingStatus}
                                </StateLabel>
                            </td>
                            {user.id !== authUser.id && (
                                <>
                                    <td>
                                        <Button
                                            size="s"
                                            onClick={() => onUserDetailsOpen(user.emailId)}
                                            className="user-info-icon"
                                        >
                                            <IconInfo slot="icon"></IconInfo>
                                        </Button>
                                    </td>
                                    <td className="zui-icon-p-r-32 zui-icon-p-l-24">
                                        <Button
                                            size="s"
                                            className="user-delete-icon"
                                            onClick={() => removeUser(user)}
                                        >
                                            <IconDelete slot="icon"></IconDelete>
                                        </Button>
                                    </td>
                                </>
                            )}
                            {user.id === authUser.id && (
                                <>
                                    <td></td>

                                    <td className="zui-icon-p-r-32 zui-icon-p-l-24">
                                        <Button onClick={onEditOpen}>
                                            <IconEdit slot="icon"></IconEdit>
                                        </Button>
                                    </td>
                                </>
                            )}
                        </tr>
                    )
                })}
            </tbody>
        </table>
    )
}

export default Index
